import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ReactCSSTransitionReplace from 'react-css-transition-replace';

import Buttonlet from 'components/Buttonlet';
import Contacts from 'components/Contacts';
import MediaLgDown from 'components/Responsive/MediaLgDown';

import GoBackButton from './components/GoBackButton';
import MessagePreferences from './components/MessagePreferences';
import Subscriptions from './components/Subscriptions';
import MetaQualities from './components/MetaQualities';
import MessageMethod from './components/MessageMethod';
import AuthMethods from './components/AuthMethods';
import MapSettings from 'components/Account/components/MapSettings';

export function Account(props) {
  const {
    hash,
    loggedIn,
    message,
    onLogout,
    onSummonChangeUsernameModal,
    onSummonDeactivateAccountModal,
    onSummonPasswordResetRequestModal,
    data: { name },
  } = props;

  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView();
      }
    }
  });

  return (
    <div className="content container">
      <div className="account" style={{ margin: 10 }}>
        <h1 className="heading heading--1" style={{ marginTop: 5 }}>
          <GoBackButton />
          Account settings
        </h1>

        <MediaLgDown>
          <hr />
        </MediaLgDown>

        <ReactCSSTransitionReplace transitionName="fade-wait" transitionEnterTimeout={100} transitionLeaveTimeout={100}>
          {message ? (
            <div key="message" style={{ paddingBottom: 24 }}>
              <p style={{ padding: 12, background: '#3f7277', color: '#fff' }}>
                {message}
              </p>
            </div>
          ) : <p key="none" />}
        </ReactCSSTransitionReplace>

        <div className="account__body">
          <div className="account__left">
            <div>
              <div>
                <h2 className="heading heading--2">User profile</h2>
                <p>
                  Username:
                  {' '}
                  {name}
                  {' '}
                  (
                  <button
                    className="button--link"
                    onClick={onSummonChangeUsernameModal}
                    type="button"
                  >
                    edit
                  </button>
                  )
                </p>
                <ul className="list--padded">
                  <li>
                    <button
                      className="button button--primary"
                      onClick={onLogout}
                      type="button"
                    >
                      Log out
                    </button>
                  </li>
                  <li>
                    <button
                      className="button button--primary"
                      onClick={onSummonPasswordResetRequestModal}
                      type="button"
                    >
                      Reset password
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      className="button button--dangerous"
                      onClick={onSummonDeactivateAccountModal}
                    >
                      Deactivate Account
                    </button>
                    <Buttonlet
                      type="question"
                      title="This will permanently remove your user account and all characters IN ALL STORYNEXUS WORLDS attached to it. Please note: deactivation does not cancel mobile Exceptional Friendship. To do that, please access your device's Google/Apple account settings."
                    />
                  </li>
                </ul>
              </div>
              <hr />
              <AuthMethods />
            </div>
            <hr />

            <div>
              <MessagePreferences />
              <hr />
              <MessageMethod />
            </div>
            <hr />
            <MetaQualities />
            <hr />
            <MapSettings />
          </div>
          <div className="account__right">
            <MediaLgDown>
              <hr />
            </MediaLgDown>
            <Subscriptions style={{ margin: '3.2em' }} />
            <hr />
            <h2 className="heading heading--2">Blocked Users</h2>
            <p>
              Receiving abusive messages via StoryNexus? Report the troublemaker at
              {' '}
              <a href="mailto:abuse@storynexus.com">abuse@storynexus.com</a>
              .
            </p>
            <hr />
            {loggedIn && <Contacts />}
          </div>
        </div>
      </div>
    </div>
  );
}

Account.displayName = 'Account';

Account.propTypes = {
  data: PropTypes.shape({}).isRequired,
  loggedIn: PropTypes.bool.isRequired,
  message: PropTypes.string,
  onLogout: PropTypes.func.isRequired,
  onSummonChangeUsernameModal: PropTypes.func.isRequired,
  onSummonDeactivateAccountModal: PropTypes.func.isRequired,
  onSummonPasswordResetRequestModal: PropTypes.func.isRequired,
};

Account.defaultProps = {
  message: undefined,
};

const mapStateToProps = ({
  user: { loggedIn },
}) => ({
  loggedIn,
});

export default withRouter(connect(mapStateToProps)(Account));